import { inject, Injectable } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ApiException } from '@unity/clients';

type Severity = 'error' | 'warning' | 'info' | 'none' | 'success' | undefined;

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private readonly notificationService = inject(NotificationService);

  private _defaultPopup(content: string, severity: Severity, sticky: boolean): void {
    this.notificationService.show({
      content: `${content}`,
      animation: { type: 'fade', duration: 200 },
      position: { horizontal: 'center', vertical: 'top' },
      type: { style: severity, icon: true },
      hideAfter: 5000,
      closable: sticky,
    });
  }

  private _defaultError(main: string, detail: string, severity: Severity, sticky = false): void {
    const content = `${main}: \t${detail}`;
    return this._defaultPopup(content, severity, sticky);
  }

  public showError(main: string, e: Error, severity: 'error' | 'warning'): void {
    let detail = e.message || 'Unknown Error';
    if (ApiException.isApiException(e) && e.result) {
      detail = e.result.detail;
    }
    return this._defaultError(main, detail, severity);
  }

  public showInfo(content: string): void {
    return this._defaultPopup(content, 'info', false);
  }
}
